import PropTypes from 'prop-types'

// Internal components
import Button from '../Button/Button'
import CorrelatedColumn from '../CorrelatedColumn/CorrelatedColumn'

const Correlated = (props) => {
  const { correlatedEntryList, optionalButtonGroup, correlatedTitle } = props

  // This splits up entries in two columns.
  const splitEntries = (entries) => {
    const columns = [[], []]
    const half = Math.ceil(entries.length / 2)
    columns[0] = entries.slice(0, half)
    columns[1] = entries.slice(-half)
    return columns
  }

  const columns = correlatedEntryList ? splitEntries(correlatedEntryList) : []

  return (
    <div className="Correlated">
      <div className="Correlated-container">
        {columns.map((column, index) => {
          return (
            <CorrelatedColumn
              column={column}
              key={`Correlated-list-${index}`}
              title={correlatedTitle?.[index]?.title || false}
              button={optionalButtonGroup?.[index]?.button || false}
              isSecondColumn={index === 1}
            />
          )
        })}
        {optionalButtonGroup?.length === 1 && (
          <Button
            href={optionalButtonGroup?.[0]?.button?.url}
            target={optionalButtonGroup?.[0]?.button?.target}
            label={optionalButtonGroup?.[0]?.button?.text || optionalButtonGroup?.[0]?.button?.customText}
            icon={{ id: 'icon-chevron-right' }}
            modifiers={['Button--correlated']}
          />
        )}
      </div>
    </div>
  )
}

Correlated.propTypes = {
  correlatedEntryList: PropTypes.array,
  optionalButtonGroup: PropTypes.array,
  correlatedTitle: PropTypes.array
}

export default Correlated
